module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAADhJREFUKBVjZMACXssx/EcXFn3EwIguxoQuQAp/iGpmxBY4xPp7iPqZImdjpBpQYGELxNEUBklGAKfYCCR6/iFwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/injury-icon.png
// module id = B5Qi
// module chunks = 0 19